import * as THREE from 'three';
import Time from '../Utils/Time';
import Application from '../Application';
export class CameraKeyframeInstance {
    constructor(keyframe) {
        this.position = keyframe.position;
        this.focalPoint = keyframe.focalPoint;
    }
    update() { }
}
const keys = {
    idle: {
        position: new THREE.Vector3(-20000, 12000, 20000),
        focalPoint: new THREE.Vector3(0, -1000, 0),
    },
    monitor: {
        position: new THREE.Vector3(0, 950, 2000),
        focalPoint: new THREE.Vector3(0, 950, 0),
    },
    desk: {
        position: new THREE.Vector3(0, 1800, 5500),
        focalPoint: new THREE.Vector3(0, 500, 0),
    },
    loading: {
        position: new THREE.Vector3(-35000, 35000, 35000),
        focalPoint: new THREE.Vector3(0, -5000, 0),
    },
    orbitControlsStart: {
        position: new THREE.Vector3(-15000, 10000, 15000),
        focalPoint: new THREE.Vector3(-100, 350, 0),
    },
    // Placeholder values, overwritten by FocusKeyframe.set() before use
    focus: {
        position: new THREE.Vector3(0, 1800, 5500),
        focalPoint: new THREE.Vector3(0, 500, 0),
    },
};
export class MonitorKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.monitor;
        super(keyframe);
        this.application = new Application();
        this.sizes = this.application.sizes;
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.targetPos = new THREE.Vector3().copy(keyframe.position);
    }
    update() {
        const aspect = this.sizes.height / this.sizes.width;
        const additionalZoom = this.sizes.width < 768 ? 0 : 600;
        this.targetPos.z = this.origin.z + aspect * 1200 - additionalZoom;
        this.position.copy(this.targetPos);
    }
}
export class LoadingKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.loading;
        super(keyframe);
    }
    update() { }
}
export class DeskKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.desk;
        super(keyframe);
        this.application = new Application();
        this.mouse = this.application.mouse;
        this.sizes = this.application.sizes;
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.originFoc = new THREE.Vector3().copy(keyframe.focalPoint);
        this.targetFoc = new THREE.Vector3().copy(keyframe.focalPoint);
        this.targetPos = new THREE.Vector3().copy(keyframe.position);
    }
    update() {
        const sway = DeskKeyframe.SWAY;
        const mx = this.mouse.x - this.sizes.width / 2;
        const my = this.mouse.y - this.sizes.height / 2;
        // Anchor to desk origin + tiny mouse offset (keeps FocusKeyframe / click-zoom unchanged)
        const focX = this.originFoc.x + mx * sway;
        const focY = this.originFoc.y - my * sway;
        const posX = this.origin.x + mx * sway * 0.5;
        const posY = this.origin.y - my * sway * 0.5;
        this.targetFoc.x += (focX - this.targetFoc.x) * 0.04;
        this.targetFoc.y += (focY - this.targetFoc.y) * 0.04;
        this.targetPos.x += (posX - this.targetPos.x) * 0.025;
        this.targetPos.y += (posY - this.targetPos.y) * 0.025;
        const aspect = this.sizes.height / this.sizes.width;
        this.targetPos.z = this.origin.z + aspect * 3000 - 1800;
        this.focalPoint.copy(this.targetFoc);
        this.position.copy(this.targetPos);
    }
}
/** Mouse parallax amplitude vs screen half-size. Was ~1.0 (hard to read props). */
DeskKeyframe.SWAY = 0.1;
export class IdleKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.idle;
        super(keyframe);
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.time = new Time();
    }
    update() {
        this.position.x =
            this.origin.x +
                Math.sin((this.time.elapsed + 19000) * 0.00008) * IdleKeyframe.AMP_X;
        this.position.y =
            this.origin.y +
                Math.sin((this.time.elapsed + 1000) * 0.000004) * IdleKeyframe.AMP_Y;
        this.position.z = this.origin.z;
    }
}
/** Was ±origin.x (~20k) — caused photo/text shimmer with mipmaps. */
IdleKeyframe.AMP_X = 180;
IdleKeyframe.AMP_Y = 60;
export class OrbitControlsStart extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.orbitControlsStart;
        super(keyframe);
    }
    update() { }
}
/**
 * Dynamic keyframe used to zoom the camera onto a desk prop
 * (resume paper, sticky notes). Position/focal point are set at runtime.
 */
export class FocusKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.focus;
        super({
            position: new THREE.Vector3().copy(keyframe.position),
            focalPoint: new THREE.Vector3().copy(keyframe.focalPoint),
        });
    }
    set(position, focalPoint) {
        this.position.copy(position);
        this.focalPoint.copy(focalPoint);
    }
    update() { }
}
